export default __webpack_public_path__ + "static/media/article_6.d3202567.jpg";